import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, Clock } from 'lucide-react';
import { CTAButton } from './CTAButton';
function useCountdown(hours: number) {
  const [endTime] = useState(() => {
    const saved = localStorage.getItem('serigrafia-countdown-end');
    if (saved) {
      const parsed = parseInt(saved);
      if (parsed > Date.now()) return parsed;
    }
    const end = Date.now() + hours * 60 * 60 * 1000;
    localStorage.setItem('serigrafia-countdown-end', end.toString());
    return end;
  });
  const [timeLeft, setTimeLeft] = useState(() => Math.max(0, endTime - Date.now()));
  useEffect(() => {
    const interval = setInterval(() => {
      const remaining = Math.max(0, endTime - Date.now());
      setTimeLeft(remaining);
      if (remaining <= 0) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, [endTime]);
  const h = Math.floor(timeLeft / (1000 * 60 * 60));
  const m = Math.floor(timeLeft % (1000 * 60 * 60) / (1000 * 60));
  const s = Math.floor(timeLeft % (1000 * 60) / 1000);
  return {
    hours: h,
    minutes: m,
    seconds: s
  };
}
const items = [{
  label: 'Tomo 1: Fundamentos sin frustración',
  price: '$5.990',
  isBonus: false
}, {
  label: 'Tomo 2: Preparación correcta',
  price: '$5.990',
  isBonus: false
}, {
  label: 'Tomo 3: Estampado profesional',
  price: '$6.990',
  isBonus: false
}, {
  label: 'Tomo 4: Errores comunes y soluciones',
  price: '$5.990',
  isBonus: false
}, {
  label: 'Tomo 5: Optimización del proceso',
  price: '$5.990',
  isBonus: false
}, {
  label: 'Tomo 6: Cómo ganar dinero con serigrafía',
  price: '$7.990',
  isBonus: false
}, {
  label: '🎁 BONO: Guía rápida 24hs',
  price: '$3.990',
  isBonus: true
}, {
  label: '🎁 BONO: Lista de proveedores',
  price: '$3.990',
  isBonus: true
}, {
  label: '🎁 BONO: Checklist paso a paso',
  price: '$3.070',
  isBonus: true
}];
export function OfferSection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(2);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section id="oferta" className="py-12 bg-darker relative overflow-hidden" data-id="element-98">
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-accent-pink/20 rounded-full blur-[120px] pointer-events-none" data-id="element-99" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-accent-yellow/20 rounded-full blur-[120px] pointer-events-none" data-id="element-100" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-101">
        <div className="max-w-5xl mx-auto bg-card rounded-3xl border border-white/10 overflow-hidden shadow-2xl" data-id="element-102">
          <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-103">
            {/* Left Side */}
            <div className="p-6 lg:p-10 bg-dark/50 flex flex-col items-center justify-center border-b lg:border-b-0 lg:border-r border-white/10" data-id="element-104">
              <h2 className="text-3xl md:text-4xl font-bold text-center mb-6" data-id="element-105">
                ACCEDÉ HOY AL{' '}
                <span className="text-gradient-primary" data-id="element-106">
                  KIT DE SERIGRAFÍA PRO
                </span>
              </h2>

              <motion.img animate={{
              y: [0, -10, 0]
            }} transition={{
              repeat: Infinity,
              duration: 5,
              ease: 'easeInOut'
            }} src="https://cdn.magicpatterns.com/uploads/mwiQsGXbTYiYGCZvg5ogzk/Kit_de_Cerigrafia_PRO.png" alt="Kit de Serigrafía PRO" className="w-full max-w-xs h-auto object-contain drop-shadow-2xl mb-6" data-id="element-107" />

              <div className="text-center w-full" data-id="element-108">
                <p className="text-gray-400 text-lg line-through mb-1" data-id="element-109">
                  Valor total: $49.990
                </p>
                <div className="bg-accent-yellow/10 border border-accent-yellow/30 rounded-xl py-3 px-6 inline-block" data-id="element-110">
                  <p className="text-accent-yellow font-bold text-sm uppercase tracking-wider mb-1" data-id="element-111">
                    Precio de lanzamiento
                  </p>
                  <p className="text-5xl md:text-6xl font-bold text-white" data-id="element-112">
                    $19.990
                  </p>
                </div>
              </div>

              {/* CTA Button */}
              <div className="mt-6 w-full flex justify-center" data-id="element-113">
                <CTAButton text="DESCARGAR AHORA Y EMPEZAR HOY" className="w-full max-w-xs" onClick={() => window.open('https://checkout.tusbeneficios.shop/cart/50957600588009:1', '_blank')} data-id="element-114" />
              </div>

              {/* Countdown Timer */}
              <div className="mt-5 bg-dark/80 border border-accent-pink/30 rounded-xl p-4 w-full max-w-xs text-center mx-auto" data-id="element-115">
                <p className="text-accent-pink text-sm font-bold uppercase tracking-wider mb-2" data-id="element-116">
                  La oferta termina en
                </p>
                <div className="flex items-center justify-center gap-2 font-mono text-3xl font-bold text-white" data-id="element-117">
                  <span className="bg-accent-pink/20 px-3 py-1 rounded-lg" data-id="element-118">
                    {pad(hours)}
                  </span>
                  <span className="text-accent-pink animate-pulse" data-id="element-119">:</span>
                  <span className="bg-accent-pink/20 px-3 py-1 rounded-lg" data-id="element-120">
                    {pad(minutes)}
                  </span>
                  <span className="text-accent-pink animate-pulse" data-id="element-121">:</span>
                  <span className="bg-accent-pink/20 px-3 py-1 rounded-lg" data-id="element-122">
                    {pad(seconds)}
                  </span>
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div className="p-6 lg:p-10 flex flex-col justify-center" data-id="element-123">
              <h3 className="text-2xl font-bold mb-4 text-white" data-id="element-124">
                ¿Qué te llevás hoy?
              </h3>

              <ul className="space-y-3 mb-6" data-id="element-125">
                {items.map((item, index) => <li key={index} className="flex items-center justify-between gap-3" data-id="element-126">
                    <div className="flex items-center gap-2" data-id="element-127">
                      <Check className="w-5 h-5 text-accent-cyan shrink-0" data-id="element-128" />
                      <span className={item.isBonus ? 'text-accent-yellow font-medium text-sm' : 'text-gray-300 text-sm'} data-id="element-129">
                        {item.label}
                      </span>
                    </div>
                    <span className="text-gray-500 text-xs line-through shrink-0" data-id="element-130">
                      {item.price}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}